import { useEffect, useState } from 'react';

// Returns `value` after it has stopped changing for `delayMs` — for debouncing an input
// (e.g. a search box) before it drives a query.
const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);

    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
